import script from "./Nav.vue?vue&type=script&lang=ts&setup=true"
export * from "./Nav.vue?vue&type=script&lang=ts&setup=true"

import "./Nav.vue?vue&type=style&index=0&id=5bf6ff3a&lang=scss&scoped=true"

import exportComponent from "/Users/huangliu/Desktop/work/2024/develop/fdyun/ycx-website/node_modules/.store/vue-loader@16.8.3/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-5bf6ff3a"]])

export default __exports__